import { Annotation } from '@/types/models';
import { AnnotationItem } from '@/components/Map/Drawer/BioEntityDrawer/AnnotationItem/AnnotationItem.component';
import React from 'react';
import { ONE, ZERO } from '@/constants/common';

type AnnotationItemListProps = {
  annotations: Annotation[];
};

export const AnnotationItemList = ({ annotations }: AnnotationItemListProps): React.ReactNode => {
  const isAnnotationAvailable = annotations.length > ZERO;
  const sortedAnnotations = annotations.slice();
  sortedAnnotations.sort((a, b) => {
    if (a.type < b.type) {
      return -ONE;
    }
    if (a.type > b.type) {
      return ONE;
    }
    return ZERO;
  });

  function uniqBy(a: Annotation[]): Annotation[] {
    const seen: Map<string, boolean> = new Map();
    return a.filter((item: Annotation) => {
      const k = `${item.type}:${item.resource}`;
      if (seen.get(k)) {
        return false;
      }
      seen.set(k, true);
      return true;
    });
  }

  const filteredAnnotations = uniqBy(sortedAnnotations);

  return (
    <div>
      <h3 className="font-semibold">
        Annotations: {!isAnnotationAvailable && <span className="font-normal">No annotations</span>}
      </h3>
      <div className="flex max-h-full flex-col gap-2 overflow-x-hidden pt-2">
        {isAnnotationAvailable &&
          filteredAnnotations.map(annotation => (
            <AnnotationItem
              key={annotation.id}
              type={annotation.type}
              link={annotation.link}
              resource={annotation.resource}
            />
          ))}
      </div>
    </div>
  );
};
